// page src/main.tsx
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { bootstrapRenderSession } from './utils/renderSessionBootstrap'

// Must run before the app tree renders — ProtectedRoute reads localStorage synchronously.
bootstrapRenderSession()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
  
)
